import React from "react";
import type { ReactElement } from "react";

import type { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import type { StackNavigationProp } from "@react-navigation/stack";

import type { HubTabNavigatorProps } from "pianofunclub-crm/navigation/HubNavigator";
import defaultNavOptions from "pianofunclub-crm/navigation/utils/defaultNavigationOptions";
import TeacherRegistersHubScreen, {
  screenOptions as teacherRegistersHubScreenOptions,
} from "pianofunclub-crm/screens/registers/TeacherRegistersHubScreen";

export type TeacherRegistersStackNavigatorParamList = {
  TeacherRegistersHub: {
    block?: number;
    dayIndex?: number;
    startingYear?: number;
  };
};

type NavigatorProps<T extends keyof TeacherRegistersStackNavigatorParamList> = StackNavigationProp<
  TeacherRegistersStackNavigatorParamList,
  T
>;

export type TeacherRegistersStackNavigatorProps<
  T extends keyof TeacherRegistersStackNavigatorParamList,
> = CompositeNavigationProp<NavigatorProps<T>, HubTabNavigatorProps<"RegistersHubTab">>;

export type TeacherRegistersStackRouteProps<
  T extends keyof TeacherRegistersStackNavigatorParamList,
> = RouteProp<TeacherRegistersStackNavigatorParamList, T>;

const TeacherRegistersStackNavigator =
  createStackNavigator<TeacherRegistersStackNavigatorParamList>();

const TeacherRegistersNavigator = (): ReactElement => {
  return (
    <TeacherRegistersStackNavigator.Navigator screenOptions={defaultNavOptions}>
      <TeacherRegistersStackNavigator.Screen
        component={TeacherRegistersHubScreen}
        name="TeacherRegistersHub"
        options={teacherRegistersHubScreenOptions}
      />
    </TeacherRegistersStackNavigator.Navigator>
  );
};

export default TeacherRegistersNavigator;
